module.exports = __webpack_public_path__ + "static/media/first-aid.afec18ca.svg";